import { subscriptionTypes } from '../../constants/statuses';

export const areSubscriptionsPending = state => state.subscription.pending;
export const isSubscriptionsError = state => state.subscription.error;
export const getSubscriptionsErrorMessage = state => state.subscription.message;

export const getSubscriptions = (state) => {
    const subscribtionData = state?.subscription?.subscriptionsList;
    return subscribtionData.length ? subscribtionData.map(sub => ({
        ...sub,
        actions: sub.actions && sub.actions
            .map(action => (typeof action === 'string' ? ({ type: action }) : action)),
    })) : subscribtionData;
};

export const getActiveSubscriptions = state =>
    state?.subscription?.subscriptionsList.filter(subscription => subscription.status === '1');

export const getExpiredSubscriptions = state =>
    state?.subscription?.subscriptionsList.filter(subscription => subscription.status === '-1');

export const getSubscriptionById = (state, subscriptionId) =>
    (state?.subscription?.subscriptionsList || []).find(sub => sub.id === subscriptionId);

export const getSubscriptionDelivery = (state, subscriptionId) => {
    const subscription = getSubscriptionById(state, subscriptionId);

    return subscription?.delivery;
};

export const getSubscriptionExpirationDate = (state, subscriptionId) => {
    const subscription = getSubscriptionById(state, subscriptionId);
    const isEvergreen = subscription?.renewalInformation?.renewalPolicy === subscriptionTypes.EVERGREEN;

    return !isEvergreen && subscription?.product?.expires;
};

export const getSingleSubscription = state => state.subscription.subscription;
export const getSingleSubscriptionPending = state => state.subscription.subscriptionPending;
